import { Button } from '@fluentui/react-components';
import { Calculator20Regular } from '@fluentui/react-icons';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface CalculateButtonProps {
    onClick: () => void;
    disabled: boolean;
}

const CalculateButton: React.FC<CalculateButtonProps> = ({ onClick, disabled }) => {
    const { t } = useTranslation();

    return (
        <Button
            appearance='primary'
            onClick={onClick}
            disabled={disabled}
            icon={<Calculator20Regular />}
            aria-label={t('rerunCalculation').toString()}
        >
            {t('rerunCalculation').toString()}
        </Button>
    );
};

export default CalculateButton;
